const lockdown = {
  lockdown: 'Confinement',
  lockdown_options: 'Options de confinement',
  start_lockdown_message:
    'Pour démarrer le confinement du Site - {{site}}, saisissez votre mot de passe puis appuyez sur confirmer.',
  stop_lockdown_message:
    'Pour arrêter le confinement du Site - {{site}}, saisissez votre mot de passe puis appuyez sur confirmer.',
  settings_modal_tile: 'Confinement - {{site}}',
  start_options: 'Options de démarrage',
  stop_options: "Options d'arrêt",
  login_required: 'Mot de passe de connexion requis',
  card_pin_options: "Options d'identifiant et de code NIP",
  confirm_start_lockdown:
    'Etes-vous sûr de vouloir démarrer le confinement du site {{site}}?',
  confirm_stop_lockdown:
    'Êtes-vous sûr de vouloir arrêter le confinement du site {{site}}?',
  pin_option: {
    single_swipe: 'Un seul balayage',
    double_swipe: 'Double balayage requis',
    two_men: 'Accès 2 utilisateurs (chaperon) requis',
  },
  cannot_edit:
    'Un confinement est en cours. Vous ne pouvez pas modifier les paramètres pour le moment.',
};

export default lockdown;
